export enum LinkshimResultTypes {
  ALLOW = 'allow',
  BLOCK = 'block',
  WARNING = 'warning',
  ERROR = 'error',
  OVER_LIMIT = 'overLimit',
}

export interface LinkshimResponseAjax {
  readonly message: LinkshimResultTypes;
}
